<template>
  <div class="lesson-item-component">
    <div class="course-lesson-item">
      <div class="lesson-content">
        <h4 class="lesson-title ym-two-line-ellipsis">
          第{{ lesson.seq }}课 | {{ lesson.title }}
        </h4>
      </div>
      <div v-if="challenge || practice || summary"
           class="lesson-after"
      >
        <div v-if="challenge"
             class="lesson-after-item"
        >
          <div class="lesson-after-item-left">
            <ym-img class="icon"
                    :src="require('@/assets/img/course/challenge_work.png')"
            />
            <div class="title">
              <div class="title-top">
                <span>课后挑战</span>
                <div v-if="work"
                     class="label"
                     :class="{ 'active': work.isComment }"
                >
                  {{ work.status === 'draft' ? '已保存草稿' : work.isComment ? '已评价' : '待评价' }}
                </div>
              </div>
              <div class="title-bottom">
                {{ work && work.status === 'normal' ? '我和' : '' }}{{ challenge.number }}位同学已完成
              </div>
            </div>
          </div>
          <ym-wx-open-launch-app v-if="!work"
                                 :url="`youthmba://course/challenge?id=${challenge.id}&token=${auth}`"
          >
            <div slot="button">
              <script type="text/wxtag-template">
                <style>
                  .btn {
                    width: 70px;
                    height: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 30px;
                    background-color: #02cccc;
                    color: #fff;
                    font-size: 13px;
                    box-sizing: border-box;
                    cursor: pointer;
                    border: none;
                    outline: none;
                  }
                </style>
                <button class="btn">去挑战</button>
              </script>
            </div>
            <div class="lesson-after-item-right">
              去挑战
            </div>
          </ym-wx-open-launch-app>
          <ym-wx-open-launch-app v-else-if="work && work.status === 'draft'"
                                 :url="`youthmba://work/detail?id=${work.id}&token=${auth}`"
          >
            <div slot="button">
              <script type="text/wxtag-template">
                <style>
                  .btn {
                    width: 80px;
                    height: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 30px;
                    background-color: #02cccc;
                    color: #fff;
                    font-size: 13px;
                    box-sizing: border-box;
                    cursor: pointer;
                    border: none;
                    outline: none;
                  }
                </style>
                <button class="btn">继续编辑</button>
              </script>
            </div>
            <div class="lesson-after-item-right draft">
              继续编辑
            </div>
          </ym-wx-open-launch-app>
          <ym-wx-open-launch-app v-else-if="work && work.status === 'normal'"
                                 :url="`youthmba://work/detail?id=${work.id}&token=${auth}`"
          >
            <div slot="button">
              <script type="text/wxtag-template">
                <style>
                  .btn {
                    width: 70px;
                    height: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 30px;
                    color: #13b9bf;
                    background-color: transparent;
                    border: 1px solid #02cccc;
                    font-size: 13px;
                    box-sizing: border-box;
                    cursor: pointer;
                    outline: none;
                  }
                </style>
                <button class="btn">查看</button>
              </script>
            </div>
            <div class="lesson-after-item-right is-plain">
              查看
            </div>
          </ym-wx-open-launch-app>
        </div>
        <div v-if="practice"
             class="lesson-after-item"
        >
          <div class="lesson-after-item-left">
            <ym-img class="icon"
                    :src="require('@/assets/img/course/challenge_practice.png')"
            />
            <div class="title">
              <div class="title-top">
                <span>课后练一练</span>
              </div>
              <div class="title-bottom">
                共{{ practice.number }}题
              </div>
            </div>
          </div>
          <ym-wx-open-launch-app v-if="practice && practice.status === 'complete'"
                                 :url="`youthmba://course/practice?id=${lesson.id}&token=${auth}`"
          >
            <div slot="button">
              <script type="text/wxtag-template">
                <style>
                  .btn {
                    width: 70px;
                    height: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 30px;
                    color: #13b9bf;
                    background-color: transparent;
                    border: 1px solid #02cccc;
                    font-size: 13px;
                    box-sizing: border-box;
                    cursor: pointer;
                    outline: none;
                  }
                </style>
                <button class="btn">看解析</button>
              </script>
            </div>
            <div class="lesson-after-item-right is-plain">
              看解析
            </div>
          </ym-wx-open-launch-app>
          <ym-wx-open-launch-app v-else
                                 :url="`youthmba://course/practice?id=${lesson.id}&token=${auth}`"
          >
            <div slot="button">
              <script type="text/wxtag-template">
                <style>
                  .btn {
                    width: 70px;
                    height: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 30px;
                    background-color: #02cccc;
                    color: #fff;
                    font-size: 13px;
                    box-sizing: border-box;
                    cursor: pointer;
                    border: none;
                    outline: none;
                  }
                </style>
                <button class="btn">去答题</button>
              </script>
            </div>
            <div class="lesson-after-item-right">
              去答题
            </div>
          </ym-wx-open-launch-app>
        </div>
        <div v-if="summary"
             class="lesson-after-item"
        >
          <div class="lesson-after-item-left">
            <ym-img class="icon"
                    :src="require('@/assets/img/course/challenge_summary.png')"
            />
            <div class="title">
              <div class="title-top">
                <span>学习小结</span>
              </div>
              <div class="title-bottom">
                收获{{ summary.number }}个知识点
              </div>
            </div>
          </div>
          <ym-wx-open-launch-app :url="`youthmba://course/summary?id=${lesson.id}&token=${auth}`">
            <div slot="button">
              <script type="text/wxtag-template">
                <style>
                  .btn {
                    width: 70px;
                    height: 33px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 30px;
                    background-color: #02cccc;
                    color: #fff;
                    font-size: 13px;
                    box-sizing: border-box;
                    cursor: pointer;
                    border: none;
                    outline: none;
                  }
                </style>
                <button class="btn">去查看</button>
              </script>
            </div>
            <div class="lesson-after-item-right">
              去查看
            </div>
          </ym-wx-open-launch-app>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import YmWxOpenLaunchApp from '@/components/YmWxOpenLaunchApp';
  import { getAuth } from '@/utils';

  export default {
    name: 'CourseDetailLessonItem',
    components: {
      YmWxOpenLaunchApp,
    },
    props: {
      courseId: {
        type: Number,
        required: true,
      },
      lesson: {
        type: Object,
        required: true,
      },
      work: {
        type: Object,
      },
      practice: {
        type: Object,
      },
      challenge: {
        type: Object,
      },
      summary: {
        type: Object,
      },
    },
    computed: {
      auth() {
        return getAuth();
      },
    },
    methods: {},
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .course-lesson-item {
    overflow: hidden;
    margin: @size-base;
    padding: @size-base @size-base 0;
    border-radius: @border-radius-medium;
    background: @color-white;
  }

  .lesson-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
  }

  .lesson-title {
    flex: 1;
    overflow: hidden;
    font-size: @font-size-medium;
    font-weight: @font-weight-bold;
    margin: 0;
    line-height: 1.4;
    padding-bottom: 30px;
  }

  .lesson-after {
    display: flex;
    flex-direction: column;
    border-top: @border-base;
    padding-bottom: @size-base;
    &-item {
      margin-top: @size-base;
      border-radius: @border-radius-medium;
      height: 120px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: @size-small;
      padding-right: @size-base;
      &-left {
        display: flex;
        align-items: center;
        .icon {
          width: 70px;
          height: 70px;
          margin-right: 20px;
        }
        .title {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 70px;
          &-top {
            display: flex;
            align-items: center;
            span {
              color: @color-text-base;
              font-size: @font-size-medium;
              font-weight: @font-weight-bold;
              line-height: 1;
            }
            .label {
              height: 28px;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0 12px;
              margin-left: 10px;
              box-sizing: border-box;
              border-radius: 7px;
              color: #FF8500;
              font-size: 20px;
              background-color: #FEF3E7;
              &.active {
                color: #13b9bf;
                background-color: #E9F7F7;
              }
            }
          }
          &-bottom {
            color: #999;
            font-size: 24px;
          }
        }
      }
      &-right {
        width: 126px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: @border-radius-large;
        background-color: #02cccc;
        color: @color-white;
        font-size: 26px;
        box-sizing: border-box;
        cursor: pointer;
        &.is-plain,
        &.normal {
          color: #13b9bf;
          background-color: transparent;
          border: 1px solid #02cccc;
        }
        &.draft {
          width: 152px;
        }
      }
    }
  }

  .lesson-time {
    display: flex;
    align-items: center;
    color: @color-text-light;
  }

  .time {
    margin-left: @size-small;
  }

  .btn-type-text {
    padding: 0;
    color: @color-primary;
  }

  .will-be-live-popup {
    color: @color-text-light;
    text-align: center;
    padding: 0 @size-medium @size-medium;
    line-height: 2;
  }

  @empty-img-size: 160px;
  .empty-img {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: @size-medium auto @size-base;
    width: @empty-img-size;
    height: @empty-img-size;
    border-radius: @border-radius-round;
    background-color: @background-color-base;
  }

  .live-seq {
    font-weight: @font-weight-primary;
  }

  .live-time {
    color: @color-text-primary;
  }
</style>
